<template>
  <div v-if="netPrice && netPrice !== '0'" itemprop="offers" class="min-height-75" itemscope itemtype="https://schema.org/Offer">
    <meta itemprop="priceCurrency" content="EUR">
    <span v-if="priceIncludingTax">
            <strong class="price-incl price-focus">{{getNetPrice(quantity, netPrice, vatPercentage) | currency}}</strong> Incl. BTW <span class="small tiny-text" v-if="vatPercentage !== '21'">({{vatPercentage}}%)</span><br/>
            <strong class="price-excl color-inherit font-size-inherit">{{quantity * netPrice | currency}}</strong> Excl. BTW
            <span class="small tiny-text" v-if="minimumOrderQuantity > 1"><br/>{{getNetPrice(1, netPrice, vatPercentage) | currency}} Incl. BTW per {{unitMeasureCode | quantityPlural(1)}} </span>
        </span>
    <span v-else>
            <strong class="price-excl price-focus">{{quantity * netPrice | currency}}</strong> Excl. BTW<br/>
            <strong class="price-incl color-inherit font-size-inherit">{{getNetPrice(quantity, netPrice, vatPercentage) | currency}}</strong> Incl. BTW <span class="small tiny-text" v-if="vatPercentage !== '21'">({{vatPercentage}}%)</span>
            <span class="small tiny-text" v-if="minimumOrderQuantity > 1"><br/>{{getNetPrice(1, netPrice, 0) | currency}} Excl. BTW per {{unitMeasureCode | quantityPlural(1)}} </span>
        </span>
    <span class="tiny-text" v-if="disposalFee && disposalFee != 0"><br />{{(quantity * disposalFee) | currency}} verwijderingsbijdrage</span>
    <br>
    <meta itemprop="availability" content="https://schema.org/InStock"/>
    <meta itemprop="itemCondition" itemtype="https://schema.org/OfferItemCondition" content="https://schema.org/NewCondition"/>
    <meta itemprop="price" :content="getNetPriceForSchema(minimumOrderQuantity, netPrice, vatPercentage) " />
  </div>
</template>


<script>
import PriceViewMixin from './PriceViewMixin';

export default {
  mixins: [ PriceViewMixin ],

  props: {
    productId: {
    },
    netPrice: {
      default: 0
    },
    vatPercentage: {
      default: 21
    },
    disposalFee: {
      default: 0
    },
    minimumOrderQuantity: {
      default: 1
    },
    unitMeasureCode: {
      default: 'm'
    },
  },

  /*
   * The component's data.
   */
  data() {
    return {
      quantity: 1
    };
  },

  /**
   * Prepare the component (Vue 1.x).
   */
  ready() {
  },

  /**
   * Prepare the component (Vue 2.x).
   */
  mounted() {
    bus.$on('product-quantity-changed', function(productId, quantity) {
      if(this.productId === productId) {
        this.quantity = quantity;
      }
    }.bind(this));

  },

  methods: {
    /**
     * Prepare the component (Vue 2.x).
     */
    prepareComponent() {




    },

    setQuantity(productId, quantity)
    {

    },

    getNetPrice: function(quantity, grossPrice, vatPercentage) {
      return parseFloat(((vatPercentage / 100) + 1) * (grossPrice * quantity)).toFixed(2);
    },

    getNetPriceForSchema: function(quantity, grossPrice, vatPercentage) {
      return this.getNetPrice(quantity, grossPrice, vatPercentage).replace(',', '');
    },
  }
}
</script>


